import React, { useState } from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import {
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Grid,
} from '@material-ui/core';

type Props = {
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
  setFilter: React.Dispatch<React.SetStateAction<string>>;
};

const useStyles = makeStyles(() =>
  createStyles({
    fullWidth: {
      // margin: theme.spacing(1),
      width: '100%',
    },
  }),
);

const Search: React.FC<Props> = ({ setSearchTerm, setFilter }) => {
  const [searchInput, setSearchInput] = useState('');
  const [filterTag, setFilterTag] = useState('all');

  const handleSearchInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchInput(e.target.value);
    setSearchTerm(e.target.value);
  };

  const handleFilterSelect = (e: React.ChangeEvent<{ value: unknown }>) => {
    setFilter(e.target.value as string);
    setFilterTag(e.target.value as string);
  };

  const classes = useStyles();

  return (
    <Grid container direction="row" justifyContent="center">
      <Grid item md={8}>
        <TextField
          className={classes.fullWidth}
          label="Search"
          value={searchInput}
          onChange={handleSearchInput}
        />
      </Grid>
      <Grid item md={4}>
        <FormControl className={classes.fullWidth}>
          <InputLabel>Filter by tag</InputLabel>
          <Select value={filterTag} onChange={handleFilterSelect}>
            <MenuItem value="all">All</MenuItem>
            <MenuItem value="containers">Containers</MenuItem>
            <MenuItem value="architecture">Architecture</MenuItem>
            <MenuItem value="services">Services</MenuItem>
            <MenuItem value="pattern">Pattern</MenuItem>
            <MenuItem value="ECS">ECS</MenuItem>
            <MenuItem value="fargate">Fargate</MenuItem>
            <MenuItem value="docker">Docker</MenuItem>
            <MenuItem value="other">Other</MenuItem>
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default Search;
